import { render } from "./designNumberPreview.vue?vue&type=template&id=c48a749c"
import script from "./designNumberPreview.vue?vue&type=script&lang=js"
export * from "./designNumberPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__